/* The WatchLife Journal — HEllO. Small, dependency-free enhancements. Content works without it. */
(function () {
  'use strict';

  function slug(text) {
    return text.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }

  /* Reading progress */
  function initProgress(article) {
    var bar = document.querySelector('[data-jl-progress]');
    if (!bar || !article) return;
    var tick = false;
    function update() {
      var r = article.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var done = Math.min(Math.max(-r.top / (total > 0 ? total : 1), 0), 1);
      bar.style.width = (done * 100).toFixed(1) + '%';
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Contents list built from the article's h2s */
  function initToc(body, list) {
    if (!body || !list) return;
    var heads = body.querySelectorAll('h2');
    if (!heads.length) { var box = list.closest('[data-jl-toc]'); if (box) box.hidden = true; return; }
    var items = [];
    heads.forEach(function (h, i) {
      if (!h.id) h.id = slug(h.textContent) || 'section-' + (i + 1);
      var li = document.createElement('li');
      var n = document.createElement('span');
      n.textContent = String(i + 1).padStart(2, '0');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(n); li.appendChild(a);
      list.appendChild(li);
      items.push({ h: h, li: li });
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        items.forEach(function (it) { it.li.classList.toggle('is-active', it.h === e.target); });
      });
    }, { rootMargin: '0px 0px -70% 0px' });
    items.forEach(function (it) { io.observe(it.h); });
  }

  /* Taper explorer: <div data-jl-tool="taper"></div> anywhere in an article */
  var LOOKS = {
    0: ['Bold & sporty', 'Wear it with big divers, pilot and tool watches, and square or cushion cases.'],
    2: ['Balanced', 'Wear it with almost everything: field, everyday, sports and many dress watches.'],
    4: ['Slim & sharp', 'Wear it with dress watches, thin cases, vintage pieces and small wrists.']
  };
  function pills(name, values, current) {
    return values.map(function (v) {
      return '<button type="button" class="jl-pill" data-' + name + '="' + v + '" aria-pressed="' + (v === current) + '">' + v + ' mm</button>';
    }).join('');
  }
  function initTaper(el) {
    var state = { lug: 20, taper: 2 };
    el.classList.add('jl-tool');
    el.innerHTML =
      '<div class="jl-tool__head"><h3 class="jl-h2" style="font-size:clamp(2.8rem,3.4vw,4rem)"><span class="jl-strong">Play</span> <span class="jl-light">with taper</span></h3>' +
      '<span class="jl-label" style="color:#6b6b6b">Drawn to scale</span></div>' +
      '<div class="jl-tool__controls">' +
      '<fieldset><legend class="jl-label">Lug width</legend><div class="jl-tool__opts" data-group="lug"></div></fieldset>' +
      '<fieldset><legend class="jl-label">Taper</legend><div class="jl-tool__opts" data-group="taper"></div></fieldset></div>' +
      '<svg viewBox="0 0 680 240" role="img" aria-live="polite"></svg>' +
      '<div class="jl-tool__result"><div class="jl-tool__spec"></div><div class="jl-sticker jl-tool__badge"></div><div class="jl-tool__pairs"></div></div>';
    var svg = el.querySelector('svg');
    function render() {
      var lug = state.lug, end = lug - state.taper, s = 6, cy = 120, L = lug * s, R = end * s, x0 = 96, x1 = 604;
      el.querySelector('[data-group="lug"]').innerHTML = pills('lug', [18, 20, 22], lug);
      el.querySelector('[data-group="taper"]').innerHTML = pills('taper', [0, 2, 4], state.taper);
      svg.setAttribute('aria-label', 'A strap ' + lug + ' millimetres wide at the lugs, narrowing to ' + end + ' at the buckle');
      svg.innerHTML =
        '<rect x="20" y="50" width="76" height="140" rx="14" fill="#fff" stroke="#3e3e3e" stroke-width="1.5"/>' +
        '<circle cx="58" cy="120" r="22" fill="none" stroke="#3e3e3e"/><line x1="58" y1="120" x2="58" y2="104" stroke="#3e3e3e" stroke-width="1.5"/><line x1="58" y1="120" x2="70" y2="124" stroke="#ef4532" stroke-width="1.5"/>' +
        '<polygon points="' + x0 + ',' + (cy - L / 2) + ' ' + x1 + ',' + (cy - R / 2) + ' ' + x1 + ',' + (cy + R / 2) + ' ' + x0 + ',' + (cy + L / 2) + '" fill="#6b6b6b"/>' +
        '<polygon points="' + (x0 + 12) + ',' + (cy - L / 2 + 8) + ' ' + (x1 - 10) + ',' + (cy - R / 2 + 8) + ' ' + (x1 - 10) + ',' + (cy + R / 2 - 8) + ' ' + (x0 + 12) + ',' + (cy + L / 2 - 8) + '" fill="none" stroke="#ebebeb" stroke-dasharray="4 5"/>' +
        '<rect x="618" y="' + (cy - R / 2 - 6) + '" width="14" height="' + (R + 12) + '" rx="3" fill="none" stroke="#3e3e3e" stroke-width="1.5"/>' +
        '<line x1="96" y1="' + (cy - L / 2 - 14) + '" x2="96" y2="' + (cy + L / 2 + 14) + '" stroke="#ef4532" stroke-width="3"/>' +
        '<line x1="604" y1="' + (cy - R / 2 - 14) + '" x2="604" y2="' + (cy + R / 2 + 14) + '" stroke="#ef4532" stroke-width="3"/>' +
        '<text x="96" y="28" fill="#3e3e3e" font-weight="800" font-size="16" text-anchor="middle">' + lug + ' mm</text>' +
        '<text x="604" y="28" fill="#3e3e3e" font-weight="800" font-size="16" text-anchor="middle">' + end + ' mm</text>' +
        '<text x="350" y="228" fill="#6b6b6b" font-weight="600" font-size="11" letter-spacing="3" text-anchor="middle">LUG END → BUCKLE END</text>';
      el.querySelector('.jl-tool__spec').textContent = lug + '/' + end;
      el.querySelector('.jl-tool__badge').textContent = LOOKS[state.taper][0];
      el.querySelector('.jl-tool__pairs').innerHTML = LOOKS[state.taper][1] + '<small>Buckle you will need: <strong>' + end + ' mm</strong></small>';
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.lug) state.lug = Number(b.dataset.lug);
      if (b.dataset.taper) state.taper = Number(b.dataset.taper);
      render();
      var again = el.querySelector('button[data-' + (b.dataset.lug ? 'lug' : 'taper') + '="' + (b.dataset.lug || b.dataset.taper) + '"]');
      if (again) again.focus();
    });
    render();
  }

  /* Wide tables scroll inside a box on phones */
  function wrapTables(body) {
    body.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement.classList.contains('jl-table')) return;
      var w = document.createElement('div');
      w.className = 'jl-table';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  /* Hub: reading-path tabs */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!k) return;
        var next = tabs[(i + k + tabs.length) % tabs.length];
        select(next); next.focus();
      });
    });
  }

  function init() {
    var article = document.querySelector('[data-jl-article]');
    var body = document.querySelector('[data-jl-body]');
    initProgress(article);
    if (body) { wrapTables(body); initToc(body, document.querySelector('[data-jl-toc-list]')); }
    document.querySelectorAll('[data-jl-tool="taper"]').forEach(initTaper);
    document.querySelectorAll('[data-jl-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
